import { render, staticRenderFns } from "./AppHubSearch.vue?vue&type=template&id=31c89dca&scoped=true&"
import script from "./AppHubSearch.vue?vue&type=script&lang=js&"
export * from "./AppHubSearch.vue?vue&type=script&lang=js&"
import style0 from "./AppHubSearch.vue?vue&type=style&index=0&id=31c89dca&scoped=true&lang=css&"
import style1 from "./AppHubSearch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c89dca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
